import React from "react";
import {Button} from "react-bootstrap";

import "./style.less";

export const ButtonToggle = (props) => {
	let className = 'btn-toggle';
	if(props.active) {
		className += ' active';
	}

	return (<Button bsStyle="default" className={className} {...props}>
		<div className="btn-toggle-handler" />
	</Button>);
};
